import { useState, useEffect } from "react";
import styles from "./EditModal.module.css";

function EditModal({ isOpen, coupon, onUpdate, onClose }) {
    const [discountType, setDiscountType] = useState("");
    const [discountValue, setDiscountValue] = useState("");
    const [maxUses, setMaxUses] = useState("");
    const [expDate, setExpDate] = useState("");
    const [applicableServices, setApplicableServices] = useState("");
    const [exclusiveRole, setExclusiveRole] = useState("");
    const [firstPurchase, setFirstPurchase] = useState("");
    const [minimumValue, setMinimumValue] = useState("");
    const [partner, setPartner] = useState("");
    const [isActive, setIsActive] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (coupon && isLoading === true) {
            setDiscountType(coupon.discount_type || "");
            setDiscountValue(coupon.discount_value || "");
            setMaxUses(coupon.max_uses || "");
            setExpDate(coupon.expiration_date || "");
            setApplicableServices(coupon.applicable_services || "");
            setExclusiveRole(coupon.exclusive_role || "");
            setFirstPurchase(coupon.first_purchase || "");
            setMinimumValue(coupon.minimum_purchase_value || "");
            setPartner(coupon.partner || "");
            setIsActive(coupon.is_active || "");
            setIsLoading(false);
        }
    }, [isLoading, coupon, isOpen]);

    if (!isOpen) return null;

    const handleSubmit = (event) => {
        event.preventDefault();
        const cupom = {
            cupom: coupon.coupon_code,
            discountType,
            discountValue,
            maxUses: maxUses || null,
            expDate: expDate || null,
            applicableServices: applicableServices || null,
            exclusiveRole: exclusiveRole || null,
            firstPurchase: firstPurchase || coupon.first_purchase,
            minimumValue: minimumValue || coupon.minimum_purchase_value,
            partner: partner || coupon.partner,
            isActive: isActive || coupon.is_active
        };
        onUpdate(cupom);
        onClose();
    };

    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <h2>Editar Plano</h2>
                <form onSubmit={handleSubmit}>
                    <input name="discount_value" placeholder="Valor" value={discountValue} onChange={(e) => setDiscountValue(e.target.value)} required />
                    <select name="discount_type" placeholder="Desconto" value={discountType} onChange={(e) => setDiscountType(e.target.value)} step="0.01" required >
                        <option value="percentage">%</option>
                        <option value="fixed">R$</option>
                    </select>
                    <input name="maxuses" placeholder="Máximo de Usos" value={maxUses} onChange={(e) => setMaxUses(e.target.value)} />
                    <input name="exp" placeholder="Data de Expiração" type="date" value={expDate} onChange={(e) => setExpDate(e.target.value)} />
                    <input name="services" placeholder="Serviços Aplicaveis" value={applicableServices} onChange={(e) => setApplicableServices(e.target.value)} />
                    <select name="role" value={exclusiveRole} onChange={(e) => setExclusiveRole(e.target.value)}>
                        <option value={coupon.exclusive_role}>Cargo Exclusivo</option>
                        <option value="Administrador">Administrador</option>
                        <option value="Gerente">Gerente</option>
                        <option value="Developer">Developer</option>
                        <option value="Suporte">Suporte</option>
                        <option value="Parceiro">Parceiro</option>
                        <option value="Cliente">Cliente</option>
                        <option value="Beta">Beta</option>
                        <option value="Booster">Booster</option>
                        <option value="Membro">Membro</option>
                    </select>
                    <select name="firstpurchase" value={firstPurchase} onChange={(e) => setFirstPurchase(e.target.value)}>
                        <option value={coupon.first_purchase}>Primeira Compra</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <input name="minimum" placeholder="Valor Minimo" value={minimumValue} onChange={(e) => setMinimumValue(e.target.value)} />
                    <select name="partner" value={partner} onChange={(e) => setPartner(e.target.value)}>
                        <option value={coupon.partner}>Parceiro</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <select name="ativo" value={isActive} onChange={(e) => setIsActive(e.target.value)}>
                        <option value={coupon.is_active}>Ativo</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                    </select>
                    <div className={styles.buttons}>
                        <button className={styles.cancelButton} type="button" onClick={onClose}>Cancelar</button>
                        <button className={styles.confirmButton} type="submit">Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditModal;
